
let host = '' ///10.255.5.29;  https://proxy.szzt.com.cn    
let path = ''           //csp_zhang csp
let storeName = 'eg360'

let isdev = 1

if (isdev) {  
  host += 'http://10.255.5.20:8877'
  path = ''
} else {
  host += 'http://10.255.5.34:8788'
  path = ''
}

export const rqsPre = host + path;

export default {
  install(Vue) {
    Vue.prototype.$rqsPre = rqsPre    
    Vue.prototype.$formlbWidth = '160px' //行控件label宽度
       
    // logout
    // Vue.prototype.$logout = function (_this) {
    //   localStorage.token = ''         
    //   // _this.$router.replace({ path: '/login' })
    // }
    // storage get
    Vue.prototype.$getTmp = function (prop) {
      if (JSON && localStorage[storeName]) {
        var obj = JSON.parse(localStorage[storeName])
        if (!obj) {
          return ''
        } else {
          return obj[prop]
        }
      } else {
        return ''
      }
    }
    // storage set
    Vue.prototype.$setTmp = function (key, vl) {
      if (JSON && key) {
        vl = vl ? vl : ''
        var obj = localStorage[storeName]
        if (!obj) {
          obj = {}
        } else {
          obj = JSON. rse(obj)
        }
        obj[key] = vl
        localStorage[storeName] = JSON.stringify(obj)
      }
    }
    // storage clear
    // Vue.prototype.$clearTmp = function () {
    //   localStorage[storeName] = ''
    // }
  }
}

